import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

class SubscriptionsAnalytics extends BaseAnalytics {
    constructor(category: string) {
        super();
        this.category = category;
    }

    clickMoreSubscriptions() {
        this.send('click_more_subscriptions');
    }

    clickSubscriptionsCheckBox(title: string) {
        this.send('click on the subscription check-box', title);
    }
}

export default SubscriptionsAnalytics;
